import type { App } from 'vue'
import { VueQueryPlugin } from '@tanstack/vue-query'
import appQueryClient from '@/libs/appQueryClient'
import router from '@/router'
import { createPinia } from 'pinia'
import { i18nInstall } from '@/libs/i18n'
import appUsePrimeVue from '@/libs/appUsePrimeVue'
import appUseSentry from '@/libs/appUseSentry'

const pinia = createPinia()

const setupApp = async (app: App) => {
  i18nInstall(app)

  app.use(VueQueryPlugin, { queryClient: appQueryClient })

  app.use(pinia)

  app.use(router)

  await appUseSentry(app)

  await appUsePrimeVue(app)

  return app
}

export default setupApp
